import { create } from 'zustand';

export const useToastStore = create((set) => ({
  message: '',
  type: 'success',
  visible: false,
  showToast: (message, type = 'success') => {
    set({ message, type, visible: true });
  },
  hideToast: () => set({ visible: false }),
}));
